// Function to get participant data by ID
const getParticipantData = (roomChatParticipants, participantId) => {
  if (!roomChatParticipants || !Array.isArray(roomChatParticipants)) {
    return null;
  }
  return roomChatParticipants.find(
    (user) => user.id?.toString() === participantId?.toString()
  );
};

// Function to get the team code by ID
const getTeamCode = (roomTeams, teamId) => {
  if (!roomTeams || !Array.isArray(roomTeams)) {
    return null;
  }
  const teamIndex = roomTeams.findIndex(
    (item) => item.id?.toString() === teamId?.toString()
  );
  return `team${teamIndex + 1}`;
};

// Function to get the team data by ID
const getTeamData = (roomTeams, teamId) => {
  if (!roomTeams || !Array.isArray(roomTeams)) {
    return null;
  }
  const teamData = roomTeams.find(
    (item) => item.id?.toString() === teamId?.toString()
  );
  return teamData;
};

export { getParticipantData, getTeamCode, getTeamData };
